export enum BatchChangeFunction {
  None = 0,
  AddNumber = 1,
  Merge = 2
}
